import { Link } from "react-router-dom";
import { posts } from "../data/posts";

export default function BlogList() {
  const postList = Array.isArray(posts) ? posts : [];

  return (
    <main style={{ maxWidth: 820, margin: "0 auto", padding: 24 }}>
      <h1>Blog</h1>

      {postList.map((p) => (
        <div key={p.slug} style={{ padding: 16, borderBottom: "1px solid #ddd" }}>
          <h2 style={{ margin: 0 }}>
            <Link to={`/blog/${p.slug}`}>{p.title}</Link>
          </h2>
          <p style={{ margin: "8px 0 0" }}>{p.description}</p>
        </div>
      ))}

      {postList.length === 0 ? <p>No blog posts yet.</p> : null}
    </main>
  );
}
